<template>
    <PopupShell
        :image="require(`@/assets/img/graphic_warning_yellow.svg`)"
        title="Are you sure you want to deactivate this listing?"
        description="Deactivated listings are not visible to the public. You can choose to reactivate listings at any time."
    >

        <div class="flex">
            <GreyButton @click="$emit('cancel')" class="w-100 mr2">Cancel</GreyButton>
            <TooliabaButton @click="updateListing" class="w-100">Yes</TooliabaButton> 
        </div>

    </PopupShell>    
</template>

<script>
import PopupShell from '@/components/editListing/popups/PopupShell.vue';
import GreyButton from '@/components/buttons/GreyButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import { mapActions } from 'vuex';

export default {
    props: {
        listingID: {
            type: Number
        }
    },
    components: {
        PopupShell,
        GreyButton,
        TooliabaButton
    },
    methods: {
        updateListing() {
            this.deactivateListing(this.listingID);
            this.$router.push({ path: '/deactive-listings' });
        },
        ...mapActions('activeListings', ['deactivateListing'])
    }
};
</script>
